import React from 'react';
import SessionManager from '../../routes/SessionManager';
import SensorsDashboard from '../../components/activity-thresholds/SensorsDashboard';


function DashboardSensors () {

    let sessionManager = new SessionManager();
    let user = sessionManager.readCookie('user');
    let site =user.site_selected || this.state.site_locations[0];

    return (
        <React.Fragment>
            <div className="page-container">
                {site && <SensorsDashboard />}
            </div>
        </React.Fragment >
    )
}
export default DashboardSensors;